<div
  [ngClass]="{
    'input-field': true,
    'input-field--auto-validate': control,
    'input-field--valid': valid,
    'input-field--invalid': invalid,
    'input-field--disabled': disabled,
  }"
>
  @if (label) {
    <label class="form-label" [htmlFor]="id">{{ label }}</label>
  }

  <div class="form-control-container">
    <button type="button" class="btn-remove" (click)="remove()">
      <span class="material-symbols-outlined">{{ removeIcon() }}</span>
    </button>

    <input
      class="form-control"
      type="number"
      inputmode="numeric"
      placeholder="0"
      [id]="id"
      [disabled]="disabled"
      [readonly]="readonly"
      [min]="min"
      [(ngModel)]="value"
      (focus)="onFocus()"
      (blur)="onBlur()"
    />

    <button type="button" class="btn-add" (click)="add()">
      <span class="material-symbols-outlined">add</span>
    </button>
  </div>

  @if (control && control.errors && control.touched) {
    <cx-form-errors [control]="control" />
  } @else if (hintText) {
    <span class="form-hint-text">{{ hintText }}</span>
  }
</div>
